var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 282,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22489_9558)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8496C20.8501 25.3268 25.3273 20.8496 30.8501 20.8496H403.85V269.8H20.8501V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8501,
    y: 20.8486,
    width: 383.921,
    height: 24.8582,
    fill: "#CEDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2202 36.5906C88.2202 32.0532 91.8985 28.375 96.4358 28.375H157.341C161.878 28.375 165.557 32.0532 165.557 36.5906V48.6298H88.2202V36.5906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2342,
    y: 54.2337,
    width: 347.232,
    height: 17.2318,
    rx: 8.61592,
    stroke: "#CDCDCD",
    strokeWidth: 0.768158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3789 37.8243C36.6215 38.3303 35.7326 38.6003 34.8218 38.6003C33.6012 38.6003 32.4302 38.1153 31.5668 37.252C30.7034 36.3888 30.2183 35.2179 30.2183 33.9968C30.2183 33.0861 30.4883 32.1965 30.9944 31.4393C31.5006 30.6821 32.2196 30.0925 33.0604 29.7436C33.9012 29.3955 34.8271 29.3045 35.7198 29.482C36.6125 29.6594 37.433 30.0978 38.0768 30.7415C38.7206 31.3852 39.1591 32.2056 39.3366 33.0989C39.5141 33.9922 39.4231 34.9172 39.0749 35.7586C38.7266 36.6001 38.1362 37.3182 37.3789 37.8243Z",
    fill: "#FF6058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.189 37.8243C50.4324 38.3303 49.5419 38.6003 48.6319 38.6003C48.0272 38.6003 47.4293 38.4815 46.8705 38.2499C46.3124 38.0183 45.804 37.6791 45.3768 37.252C44.9496 36.8249 44.6104 36.3174 44.3788 35.7587C44.1472 35.2 44.0283 34.6014 44.0283 33.9968C44.0283 33.0862 44.2983 32.1967 44.8045 31.4394C45.3106 30.6822 46.0289 30.092 46.8705 29.7438C47.7113 29.3949 48.6371 29.3047 49.5298 29.4821C50.4226 29.6596 51.2431 30.098 51.8869 30.7416C52.5307 31.3853 52.9691 32.2064 53.1466 33.099C53.3241 33.9923 53.2331 34.9165 52.8849 35.7579C52.5367 36.5993 51.9463 37.3182 51.189 37.8243Z",
    fill: "#FFBD2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 37.8243C64.2432 38.3303 63.3534 38.6003 62.4427 38.6003C61.838 38.6003 61.2393 38.4815 60.6805 38.2499C60.1217 38.0183 59.6141 37.6791 59.1869 37.252C58.7597 36.8249 58.4205 36.3173 58.1889 35.7586C57.9572 35.1999 57.8384 34.6013 57.8384 33.9968C57.8384 33.0861 58.1084 32.1965 58.6145 31.4393C59.1207 30.6821 59.8397 30.0918 60.6805 29.7436C61.5214 29.3955 62.4472 29.3045 63.3399 29.482C64.2326 29.6594 65.0532 30.0978 65.6969 30.7415C66.3407 31.3852 66.7792 32.2056 66.9567 33.0982C67.1342 33.9915 67.0432 34.9164 66.695 35.7579C66.3468 36.5993 65.7571 37.3182 64.9998 37.8243Z",
    fill: "#27C940"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.847 59.5559C390.414 59.5559 390.874 59.0961 390.874 58.5289C390.874 57.9617 390.414 57.502 389.847 57.502C389.28 57.502 388.82 57.9617 388.82 58.5289C388.82 59.0961 389.28 59.5559 389.847 59.5559Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 63.6633C390.414 63.6633 390.874 63.2035 390.874 62.6363C390.874 62.0692 390.414 61.6094 389.847 61.6094C389.28 61.6094 388.82 62.0692 388.82 62.6363C388.82 63.2035 389.28 63.6633 389.847 63.6633Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 67.7717C390.414 67.7717 390.874 67.3119 390.874 66.7447C390.874 66.1776 390.414 65.7178 389.847 65.7178C389.28 65.7178 388.82 66.1776 388.82 66.7447C388.82 67.3119 389.28 67.7717 389.847 67.7717Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.158,
    y: 35.8389,
    width: 46.0337,
    height: 4.60337,
    rx: 2.30168,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.4272,
    y: 33.9971,
    width: 8.77895,
    height: 8.77895,
    rx: 1.09737,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 317.89,
    height: 187.67,
    transform: "translate(86.4604 98.9873)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236.694,
    height: 140.178,
    transform: "translate(127.058 113.188)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.125,
    y: 144.103,
    width: 158.562,
    height: 41.786,
    stroke: "#C9C9C9",
    strokeWidth: 0.766,
    strokeLinecap: "round",
    strokeDasharray: "1.53 1.53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.125,
    y: 189.153,
    width: 158.562,
    height: 33.2982,
    stroke: "#C9C9C9",
    strokeWidth: 0.766,
    strokeLinecap: "round",
    strokeDasharray: "1.53 1.53"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_22489_9558",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 77.8496H86.4601V298.458H21.3501V77.8496Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 77.8496H86.4601V298.458H21.3501V77.8496Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4601 77.8496H85.6941V298.458H86.4601H87.2261V77.8496H86.4601Z",
    fill: "#ECECEC",
    mask: "url(#path-15-inside-1_22489_9558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6911,
    y: 120.362,
    width: 44.428,
    height: 31.406,
    rx: 3.447,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6911,
    y: 120.362,
    width: 44.428,
    height: 31.406,
    rx: 3.447,
    stroke: "#AB8B7D",
    strokeWidth: 0.766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3081 162.875C31.3081 160.76 33.0229 159.045 35.1381 159.045H72.6721C74.7874 159.045 76.5021 160.76 76.5021 162.875V187.387C76.5021 189.502 74.7874 191.217 72.6721 191.217H35.1381C33.0229 191.217 31.3081 189.502 31.3081 187.387V162.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-2_22489_9558",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 77.9873H404.85V98.9873H20.8501V77.9873Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 77.9873H404.85V98.9873H20.8501V77.9873Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.85 98.9873V98.2213H20.8501V98.9873V99.7533H404.85V98.9873Z",
    fill: "#ECECEC",
    mask: "url(#path-19-inside-2_22489_9558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8501 85.8173C28.8501 83.7021 30.5648 81.9873 32.6801 81.9873H59.0201C61.1353 81.9873 62.8501 83.7021 62.8501 85.8173V91.1573C62.8501 93.2726 61.1353 94.9873 59.0201 94.9873H32.6801C30.5648 94.9873 28.8501 93.2726 28.8501 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8501 85.8173C72.8501 83.7021 74.5648 81.9873 76.6801 81.9873H103.02C105.135 81.9873 106.85 83.7021 106.85 85.8173V91.1573C106.85 93.2726 105.135 94.9873 103.02 94.9873H76.6801C74.5648 94.9873 72.8501 93.2726 72.8501 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85 85.8173C116.85 83.7021 118.565 81.9873 120.68 81.9873H147.02C149.135 81.9873 150.85 83.7021 150.85 85.8173V91.1573C150.85 93.2726 149.135 94.9873 147.02 94.9873H120.68C118.565 94.9873 116.85 93.2726 116.85 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85 85.8173C160.85 83.7021 162.565 81.9873 164.68 81.9873H191.02C193.135 81.9873 194.85 83.7021 194.85 85.8173V91.1573C194.85 93.2726 193.135 94.9873 191.02 94.9873H164.68C162.565 94.9873 160.85 93.2726 160.85 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22489_9558)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22489_9558)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.726 89.2694V91.8746C220.726 92.377 221.135 92.7857 221.637 92.7857H224.22L225.206 93.7718C225.276 93.8416 225.369 93.8788 225.463 93.8788C225.51 93.8788 225.558 93.8697 225.603 93.8509C225.74 93.7943 225.828 93.6622 225.828 93.5142V92.7857H226.375C226.877 92.7857 227.286 92.377 227.286 91.8746V88.5947C227.286 88.0923 226.877 87.6836 226.375 87.6836H224.295M221.091 89.2694V91.8746C221.091 92.176 221.336 92.4213 221.637 92.4213H224.295C224.344 92.4213 224.39 92.4404 224.424 92.4746L225.338 93.2754L225.464 92.6035C225.464 92.5029 225.545 92.4213 225.646 92.4213H226.375C226.676 92.4213 226.921 92.176 226.921 91.8746V88.5947C226.921 88.2933 226.676 88.048 226.375 88.048H224.295",
    stroke: "url(#paint0_linear_22489_9558)",
    strokeWidth: 0.780933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.381 90.8877L218.381 90.8877C218.458 90.9193 218.538 90.9347 218.617 90.9347C218.777 90.9347 218.934 90.8717 219.052 90.7544L219.052 90.7543L219.052 90.7543L220.248 89.5579H223.436C224.155 89.5579 224.74 88.9732 224.74 88.2542V84.1231C224.74 83.404 224.155 82.8193 223.436 82.8193H217.469C216.75 82.8193 216.166 83.404 216.166 84.1231V88.2542C216.166 88.9732 216.75 89.5579 217.469 89.5579H218.002V90.3193C218.002 90.5688 218.151 90.7921 218.381 90.8877ZM216.937 84.1231C216.937 83.8297 217.176 83.5907 217.469 83.5907H223.436C223.73 83.5907 223.969 83.8297 223.969 84.1231V88.2542C223.969 88.5475 223.73 88.7865 223.436 88.7865H220.088C219.988 88.7865 219.892 88.8256 219.82 88.8954L218.878 89.7204L218.773 89.156C218.764 88.9507 218.595 88.7865 218.387 88.7865H217.469C217.176 88.7865 216.937 88.5475 216.937 88.2542V84.1231Z",
    fill: "#331863",
    stroke: "#331863",
    strokeWidth: 0.312373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46 87.6765C220.641 87.6765 220.788 87.5297 220.788 87.3485C220.788 87.1674 220.641 87.0205 220.46 87.0205C220.279 87.0205 220.132 87.1674 220.132 87.3485C220.132 87.5297 220.279 87.6765 220.46 87.6765Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.463 86.4233V86.2042C220.947 86.2042 221.34 85.8606 221.34 85.437C221.34 85.0135 220.947 84.6699 220.463 84.6699C219.979 84.6699 219.586 85.0135 219.586 85.437V85.5466",
    stroke: "#331863",
    strokeWidth: 0.702839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.819 90.0264H222.373C222.251 90.0264 222.151 90.126 222.151 90.2489V90.6941C222.151 90.817 222.251 90.9166 222.373 90.9166H222.819C222.941 90.9166 223.041 90.817 223.041 90.6941V90.2489C223.041 90.126 222.941 90.0264 222.819 90.0264Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.239 90.0264H223.794C223.671 90.0264 223.572 90.126 223.572 90.2489V90.6941C223.572 90.817 223.671 90.9166 223.794 90.9166H224.239C224.362 90.9166 224.462 90.817 224.462 90.6941V90.2489C224.462 90.126 224.362 90.0264 224.239 90.0264Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.659 90.0264H225.214C225.091 90.0264 224.992 90.126 224.992 90.2489V90.6941C224.992 90.817 225.091 90.9166 225.214 90.9166H225.659C225.782 90.9166 225.882 90.817 225.882 90.6941V90.2489C225.882 90.126 225.782 90.0264 225.659 90.0264Z",
    fill: "#331863"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 2,
    transform: "translate(204.85 95.9873)",
    fill: "#CB5C56"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22489_9558)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_22489_9558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 77.8496,
    width: 259.5,
    height: 152.405,
    rx: 7.72364,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.35,
    y: 78.0518,
    width: 260,
    height: 18,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.752 89.8744C327.116 90.2989 326.371 90.5254 325.607 90.5254C324.583 90.5254 323.6 90.1185 322.876 89.3943C322.152 88.6701 321.745 87.6879 321.745 86.6634C321.745 85.8995 321.971 85.1532 322.396 84.518C322.82 83.8827 323.424 83.3882 324.129 83.0954C324.834 82.8034 325.611 82.727 326.36 82.8759C327.109 83.0248 327.797 83.3926 328.337 83.9326C328.877 84.4726 329.245 85.1608 329.394 85.9102C329.543 86.6597 329.467 87.4356 329.175 88.1415C328.882 88.8474 328.387 89.4498 327.752 89.8744Z",
    fill: "#FF6058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.337 89.8744C338.703 90.2989 337.955 90.5254 337.192 90.5254C336.685 90.5254 336.183 90.4257 335.714 90.2314C335.246 90.0371 334.82 89.7526 334.461 89.3943C334.103 89.036 333.818 88.6102 333.624 88.1415C333.43 87.6728 333.33 87.1707 333.33 86.6635C333.33 85.8996 333.557 85.1533 333.981 84.5181C334.406 83.8828 335.008 83.3877 335.714 83.0956C336.42 82.8029 337.196 82.7272 337.945 82.8761C338.694 83.0249 339.383 83.3927 339.923 83.9327C340.463 84.4727 340.831 85.1615 340.98 85.9103C341.128 86.6597 341.052 87.435 340.76 88.1409C340.468 88.8468 339.973 89.4498 339.337 89.8744Z",
    fill: "#FFBD2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.923 89.8744C350.289 90.2989 349.542 90.5254 348.778 90.5254C348.271 90.5254 347.769 90.4257 347.3 90.2314C346.831 90.0371 346.405 89.7526 346.047 89.3943C345.688 89.036 345.404 88.6102 345.21 88.1415C345.015 87.6728 344.916 87.1706 344.916 86.6634C344.916 85.8995 345.142 85.1532 345.567 84.518C345.991 83.8827 346.594 83.3875 347.3 83.0954C348.005 82.8034 348.782 82.727 349.531 82.8759C350.28 83.0248 350.968 83.3926 351.508 83.9326C352.048 84.4726 352.416 85.1608 352.565 85.9096C352.714 86.659 352.638 87.4349 352.345 88.1409C352.053 88.8468 351.559 89.4498 350.923 89.8744Z",
    fill: "#27C940"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 180,
    transform: "translate(100.35 96.0518)",
    fill: "#FCFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.359 135.024C113.359 131.884 115.905 129.338 119.045 129.338H340.509C343.649 129.338 346.194 131.884 346.194 135.024V148.216H113.359V135.024Z",
    fill: "#F2EFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.359 135.024C113.359 131.884 115.905 129.338 119.045 129.338H340.509C343.649 129.338 346.194 131.884 346.194 135.024V148.216H113.359V135.024Z",
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 148.217,
    width: 232.835,
    height: 18.8785,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 148.217,
    width: 232.835,
    height: 18.8785,
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.175,
    y: 153.985,
    width: 7.34165,
    height: 7.34165,
    rx: 3.67082,
    stroke: "#C0C0C0",
    strokeWidth: 1.04881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.381,
    y: 155.171,
    width: 58.3615,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.778,
    y: 155.171,
    width: 28.7452,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.459,
    y: 155.171,
    width: 42.6823,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.52 156.196C329.825 156.196 330.073 155.948 330.073 155.642C330.073 155.337 329.825 155.089 329.52 155.089C329.214 155.089 328.966 155.337 328.966 155.642C328.966 155.948 329.214 156.196 329.52 156.196Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52 158.41C329.825 158.41 330.073 158.162 330.073 157.856C330.073 157.551 329.825 157.303 329.52 157.303C329.214 157.303 328.966 157.551 328.966 157.856C328.966 158.162 329.214 158.41 329.52 158.41Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52 160.624C329.825 160.624 330.073 160.376 330.073 160.07C330.073 159.764 329.825 159.517 329.52 159.517C329.214 159.517 328.966 159.764 328.966 160.07C328.966 160.376 329.214 160.624 329.52 160.624Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 167.095,
    width: 232.835,
    height: 18.8785,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 167.095,
    width: 232.835,
    height: 18.8785,
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.175,
    y: 172.863,
    width: 7.34165,
    height: 7.34165,
    rx: 3.67082,
    stroke: "#C0C0C0",
    strokeWidth: 1.04881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.381,
    y: 174.049,
    width: 58.3615,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.778,
    y: 174.049,
    width: 28.7452,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.459,
    y: 174.049,
    width: 42.6823,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.518 175.358C329.824 175.358 330.072 175.11 330.072 174.804C330.072 174.499 329.824 174.251 329.518 174.251C329.213 174.251 328.965 174.499 328.965 174.804C328.965 175.11 329.213 175.358 329.518 175.358Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 177.572C329.824 177.572 330.072 177.324 330.072 177.018C330.072 176.713 329.824 176.465 329.518 176.465C329.213 176.465 328.965 176.713 328.965 177.018C328.965 177.324 329.213 177.572 329.518 177.572Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 179.786C329.824 179.786 330.072 179.538 330.072 179.232C330.072 178.927 329.824 178.679 329.518 178.679C329.213 178.679 328.965 178.927 328.965 179.232C328.965 179.538 329.213 179.786 329.518 179.786Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 185.974,
    width: 232.835,
    height: 18.8785,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 185.974,
    width: 232.835,
    height: 18.8785,
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.175,
    y: 191.741,
    width: 7.34165,
    height: 7.34165,
    rx: 3.67082,
    stroke: "#C0C0C0",
    strokeWidth: 1.04881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.381,
    y: 192.927,
    width: 58.3615,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.778,
    y: 192.927,
    width: 28.7452,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.459,
    y: 192.927,
    width: 42.6823,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.518 193.935C329.824 193.935 330.072 193.687 330.072 193.382C330.072 193.076 329.824 192.828 329.518 192.828C329.213 192.828 328.965 193.076 328.965 193.382C328.965 193.687 329.213 193.935 329.518 193.935Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 196.149C329.824 196.149 330.072 195.901 330.072 195.595C330.072 195.29 329.824 195.042 329.518 195.042C329.213 195.042 328.965 195.29 328.965 195.595C328.965 195.901 329.213 196.149 329.518 196.149Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 198.363C329.824 198.363 330.072 198.115 330.072 197.809C330.072 197.504 329.824 197.256 329.518 197.256C329.213 197.256 328.965 197.504 328.965 197.809C328.965 198.115 329.213 198.363 329.518 198.363Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.359 204.852H346.194V218.044C346.194 221.184 343.649 223.73 340.509 223.73H119.045C115.905 223.73 113.359 221.184 113.359 218.044V204.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.359 204.852H346.194V218.044C346.194 221.184 343.649 223.73 340.509 223.73H119.045C115.905 223.73 113.359 221.184 113.359 218.044V204.852Z",
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.175,
    y: 210.62,
    width: 7.34165,
    height: 7.34165,
    rx: 3.67082,
    stroke: "#C0C0C0",
    strokeWidth: 1.04881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.381,
    y: 211.806,
    width: 58.3615,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.778,
    y: 211.806,
    width: 28.7452,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.459,
    y: 211.806,
    width: 42.6823,
    height: 4.35534,
    rx: 2.17767,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.518 213.099C329.824 213.099 330.072 212.851 330.072 212.546C330.072 212.24 329.824 211.992 329.518 211.992C329.213 211.992 328.965 212.24 328.965 212.546C328.965 212.851 329.213 213.099 329.518 213.099Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 215.313C329.824 215.313 330.072 215.065 330.072 214.76C330.072 214.454 329.824 214.206 329.518 214.206C329.213 214.206 328.965 214.454 328.965 214.76C328.965 215.065 329.213 215.313 329.518 215.313Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.518 217.527C329.824 217.527 330.072 217.279 330.072 216.973C330.072 216.668 329.824 216.42 329.518 216.42C329.213 216.42 328.965 216.668 328.965 216.973C328.965 217.279 329.213 217.527 329.518 217.527Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 103.012,
    width: 232.835,
    height: 22.0249,
    rx: 4.41719,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.359,
    y: 103.012,
    width: 232.835,
    height: 22.0249,
    rx: 4.41719,
    stroke: "#EDEDED",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.477,
    y: 107.469,
    width: 109.6,
    height: 13.1101,
    rx: 1.83541,
    stroke: "#D1D1D1",
    strokeWidth: 0.524403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.107,
    y: 107.731,
    width: 36.7082,
    height: 12.5857,
    rx: 1.57321,
    stroke: "#42296E",
    strokeWidth: 1.04881
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_22489_9558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.717,
    y: 81.207,
    width: 11.0865,
    height: 11.0865,
    rx: 5.54324,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_22489_9558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.762 87.3232V88.7913C114.762 89.0744 114.992 89.3047 115.275 89.3047H116.73L117.286 89.8604C117.326 89.8997 117.378 89.9206 117.431 89.9206C117.458 89.9206 117.484 89.9155 117.51 89.9049C117.587 89.873 117.637 89.7985 117.637 89.7152V89.3047H117.945C118.228 89.3047 118.458 89.0744 118.458 88.7913V86.9431C118.458 86.66 118.228 86.4297 117.945 86.4297H116.773M114.967 87.3232V88.7913C114.967 88.9611 115.105 89.0993 115.275 89.0993H116.773C116.8 89.0993 116.826 89.1101 116.846 89.1294L117.361 89.5806L117.431 89.202C117.431 89.1453 117.477 89.0993 117.534 89.0993H117.945C118.115 89.0993 118.253 88.9611 118.253 88.7913V86.9431C118.253 86.7733 118.115 86.635 117.945 86.635H116.773",
    stroke: "url(#paint1_linear_22489_9558)",
    strokeWidth: 0.440048
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.441 88.2349L113.441 88.2349C113.484 88.2527 113.529 88.2614 113.574 88.2614C113.664 88.2614 113.752 88.2259 113.819 88.1598L113.819 88.1598L113.819 88.1597L114.493 87.4856H116.289C116.695 87.4856 117.024 87.1561 117.024 86.751V84.4231C117.024 84.018 116.695 83.6885 116.289 83.6885H112.927C112.522 83.6885 112.192 84.018 112.192 84.4231V86.751C112.192 87.1561 112.522 87.4856 112.927 87.4856H113.227V87.9146C113.227 88.0552 113.311 88.1811 113.441 88.2349ZM112.627 84.4231C112.627 84.2578 112.762 84.1231 112.927 84.1231H116.289C116.455 84.1231 116.589 84.2578 116.589 84.4231V86.751C116.589 86.9163 116.455 87.0509 116.289 87.0509H114.403C114.346 87.0509 114.292 87.0729 114.252 87.1123L113.721 87.5772L113.661 87.2591C113.657 87.1434 113.561 87.0509 113.444 87.0509H112.927C112.762 87.0509 112.627 86.9163 112.627 86.751V84.4231Z",
    fill: "#331863",
    stroke: "#331863",
    strokeWidth: 0.176019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.612 86.4253C114.714 86.4253 114.797 86.3426 114.797 86.2405C114.797 86.1384 114.714 86.0557 114.612 86.0557C114.51 86.0557 114.427 86.1384 114.427 86.2405C114.427 86.3426 114.51 86.4253 114.612 86.4253Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.614 85.7195V85.596C114.886 85.596 115.108 85.4024 115.108 85.1637C115.108 84.925 114.886 84.7314 114.614 84.7314C114.341 84.7314 114.12 84.925 114.12 85.1637V85.2255",
    stroke: "#331863",
    strokeWidth: 0.396042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.941 87.75H115.69C115.621 87.75 115.565 87.8061 115.565 87.8754V88.1262C115.565 88.1955 115.621 88.2517 115.69 88.2517H115.941C116.01 88.2517 116.067 88.1955 116.067 88.1262V87.8754C116.067 87.8061 116.01 87.75 115.941 87.75Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.741 87.75H116.491C116.421 87.75 116.365 87.8061 116.365 87.8754V88.1262C116.365 88.1955 116.421 88.2517 116.491 88.2517H116.741C116.811 88.2517 116.867 88.1955 116.867 88.1262V87.8754C116.867 87.8061 116.811 87.75 116.741 87.75Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.542 87.75H117.291C117.222 87.75 117.166 87.8061 117.166 87.8754V88.1262C117.166 88.1955 117.222 88.2517 117.291 88.2517H117.542C117.611 88.2517 117.667 88.1955 117.667 88.1262V87.8754C117.667 87.8061 117.611 87.75 117.542 87.75Z",
    fill: "#331863"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22489_9558",
    x: 0.000102997,
    y: -0.000385284,
    width: 415.921,
    height: 281.871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.38947,
    dy: -4.38947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.23026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22489_9558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22489_9558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22489_9558",
    x: 81.919,
    y: 58.9185,
    width: 291.052,
    height: 183.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.15519,
    dy: -3.15519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.88798
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22489_9558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22489_9558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22489_9558",
    x1: 229.254,
    y1: 88.0511,
    x2: 222.058,
    y2: 92.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#009191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22489_9558",
    x1: 119.567,
    y1: 86.6368,
    x2: 115.512,
    y2: 89.3455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#009191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22489_9558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8496C20.8501 25.3268 25.3273 20.8496 30.8501 20.8496H403.85V269.8H20.8501V30.8496Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4312,
    height: 16.4312,
    fill: "white",
    transform: "translate(381.631 54.4219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22489_9558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.85 85.8173C204.85 83.7021 206.565 81.9873 208.68 81.9873H235.02C237.135 81.9873 238.85 83.7021 238.85 85.8173V91.1573C238.85 93.2726 237.135 94.9873 235.02 94.9873H208.68C206.565 94.9873 204.85 93.2726 204.85 91.1573V85.8173Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8105,
    height: 11.8105,
    fill: "white",
    transform: "translate(215.945 82.582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8684,
    height: 11.8568,
    fill: "white",
    transform: "translate(215.916 82.5586)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 77.8496,
    width: 259.5,
    height: 152.405,
    rx: 7.72364,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.85529,
    height: 8.85529,
    fill: "white",
    transform: "translate(325.09 153.429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.85529,
    height: 8.85529,
    fill: "white",
    transform: "translate(325.09 172.592)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.85529,
    height: 8.85529,
    fill: "white",
    transform: "translate(325.09 191.169)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.85529,
    height: 8.85529,
    fill: "white",
    transform: "translate(325.09 210.332)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8018,
    height: 11.8018,
    fill: "white",
    transform: "translate(109.359 80.8496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_22489_9558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.68771,
    height: 6.68118,
    fill: "white",
    transform: "translate(112.051 83.541)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Img);
export default __webpack_public_path__ + "static/media/step_4_img.7a6acaf77d70d8cd18bb60caff961e0f.svg";
export { ForwardRef as ReactComponent };